import { Injectable, inject } from '@angular/core';

import { CamBaseGridService, CamGridGraphConfig } from '@camelot/core';
import { GraphEndpoint } from '@camelot/server';
import { APPLICATION_CONFIG, IApplicationConfig } from '@camelot/utils';

import { QuotationGridRow } from './dto/quotation-grid-row';

const graphEndpoint: GraphEndpoint = {
  clientName: 'quotationService',
  endpoint: 'quotation',
};

@Injectable({
  providedIn: 'root',
})
export class CamQuotationGridService extends CamBaseGridService<QuotationGridRow> {
  protected _graphEndpoint = graphEndpoint;

  private _applicationConfig: IApplicationConfig = inject(APPLICATION_CONFIG);

  protected _gridGraph: CamGridGraphConfig = {
    entity: 'Quotation',
    idArg: 'quotationVersionId',
    // le prix de revient ne doit jamais atteindre l'application client, y compris via les mutations
    rowFields: () =>
      [
        'id',
        'parentId',
        'index',
        'hasChildren',
        'hidden',
        'rowType',
        'rowPricingType',
        'marketType',
        'description',
        'quantity',
        'unit',
        'unitSellingPrice',
        ...(this._applicationConfig.isCustomerApplication ? [] : ['unitCostPrice']),
        'exclVatTotal',
        'vatLevelId',
        'documentIds',
        'documentCount',
        'order',
        'compositionPath',
      ].join(' '),
  };

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: this._graphEndpoint });
  }
}
